import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { DeliveryOverviewComponent } from "./delivery-overview/delivery-overview.component";
import { DeliveryDetailsComponent } from "./delivery-details/delivery-details.component";
import { DeliveryUpdateComponent } from "./delivery-update/delivery-update.component";


export const DELIVERY_ROUTES: Routes = [
  {
    path: 'delivery/overview/:status',
    component: DeliveryOverviewComponent,
    canActivate: [authGuard]
  },
  {
    path: 'delivery/details/:projid/:jobid/:delid',
    component: DeliveryDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'delivery/update/:projid/:jobid/:delid',
    component: DeliveryUpdateComponent,
    canActivate: [authGuard]
  }
]
